"use client"
import { FaArrowRight, FaArrowLeft, FaHandshake } from "react-icons/fa"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRotateRight } from "@fortawesome/free-solid-svg-icons"

const OrderFormStep2 = ({
  handleStep2Submit,
  handleSkipStep2,
  handleBackToStep1,
  isGetRateButtonDisabled,
  handleGetTodayRate,
  rateLoading,
  hasRequestedRateToday,
  handleManualRefresh,
  isRefreshing,
  rateRequestSent,
  currentRate,
  detailsChangedAfterRate,
  rateRequestDetails,
  rateDate,
  isNegotiating,
  setIsNegotiating,
  userOffer,
  setUserOffer,
  handleNegotiateSubmit,
  formatDate,
  product,
}) => {
  const unitLabel =
    rateRequestDetails?.quantityType?.toLowerCase() === "mt"
      ? "Per MT"
      : "Per Bag"
  return (
    <form onSubmit={handleStep2Submit}>
      <h2 className="section-title">Rate Request & Negotiation</h2>
      <p className="section-description">
        Request today's rate for your selected product and negotiate if needed. You can also skip this step if you
        prefer.
      </p>

      <div className="rate-request-section">
        <div style={{ width: "100%", position: "relative", textAlign: "center" }}>
          <button
            type="button"
            className={`get-rate-btn ${isGetRateButtonDisabled() ? "disabled" : "active"}`}
            onClick={handleGetTodayRate}
            disabled={isGetRateButtonDisabled()}
          >
            {rateLoading ? "Requesting..." : hasRequestedRateToday() ? "Rate Requested" : "Get Today Rate"}
          </button>

        </div>

        {hasRequestedRateToday() && !currentRate && (
          <p className="fill-details-message">You've requested a rate for this grade at this site today.</p>
        )}

        {/* Rate information display */}
        {rateRequestSent && !currentRate && (
          <div className="rate-notification">
            <p>
              You will be notified shortly with the latest rates. If the rates are not displayed, please refresh after
              some time.
            </p>
          </div>
        )}

        {currentRate && !detailsChangedAfterRate && (
          <div className="rate-display">
            <div className="rate-bar">
              <span className="rate-label">Today Rate: </span>
              <span className="rate-value">
                ₹{currentRate} /<span style={{ fontSize: '15px', color: 'black' }}> {unitLabel}</span>
              </span>
              {rateRequestDetails?.status !== "close" && (
                <div className="negotiate-container">
                  <button
                    type="button"
                    className="negotiate-btn"
                    onClick={() => setIsNegotiating(true)}
                    title="Negotiate Rate"
                  >
                    <FaHandshake className="negotiate-icon" />
                    <span className="negotiate-text">Negotiate</span>
                  </button>
                </div>
              )}
            </div>
            {rateRequestDetails?.userOffer && rateRequestDetails?.status !== "close" && (
              <div className="negotiation-card">
                <div className="negotiation-row user-offer">
                  <span className="label">💬 Your Offer</span>
                  <span className="value">₹ {rateRequestDetails.userOffer} / {unitLabel}</span>
                </div>

                <div className="negotiation-row supplier-offer">
                  <span className="label">🏢 Supplier Offer</span>
                  <span className="value">  ₹{currentRate} / {unitLabel}</span>
                </div>
              </div>
            )}

            {rateRequestDetails?.status === "close" && (
              <div className="negotiation-card">
                <div className="negotiation-row final-offer">
                  <span className="label">✅ Final Offer</span>
                  <span className="value"> ₹{currentRate} / {unitLabel}</span>
                </div>
              </div>
            )}

            {rateDate && (
              <div className="rate-date">
                <small>as of {formatDate(rateDate)}</small>
              </div>
            )}
            <div className="rate-disclaimer">
              <small>*Rates are subject to change as per company policy without prior notice.</small>
            </div>

            {isNegotiating && (
              <div className="negotiate-form">
                <input
                  type="number"
                  className="negotiate-input"
                  placeholder={`₹${currentRate}`}
                  value={userOffer}
                  onChange={(e) => setUserOffer(e.target.value)}
                  onWheel={(e) => {
                    e.target.blur()
                  }}
                />
                <button type="button" className="negotiate-submit" onClick={handleNegotiateSubmit}>
                  Submit Offer
                </button>
              </div>
            )}
          </div>
        )}

        {currentRate && detailsChangedAfterRate && (
          <div className="rate-warning">
            <p>Details have changed since rate request.</p>
            <p>Rate is specific to the original details.</p>
            <p>Please get a new rate or revert to original details.</p>
          </div>
        )}
      </div>

      <div className="action-buttons">
        <button type="button" className="action-btn order-back-btn" onClick={handleBackToStep1}>
          <FaArrowLeft className="mr-2" /> Back
        </button>
        <button type="submit" className="action-btn next-step active">
          Next <FaArrowRight className="ml-2" />
        </button>
      </div>
    </form>
  )
}

export default OrderFormStep2
